import { IonMenuToggle, IonItem, IonIcon } from "@ionic/react";
import React from "react";
import { useLocation } from 'react-router-dom';

interface props {
    appPages: any
}

const MenuType: React.FC<props> = ({ appPages }) => {
    const location = useLocation();

    return (
        <>
            {appPages.map((appPage: any, index: any) => {
                return (
                    <IonMenuToggle key={index} autoHide={true}>
                        <IonItem className={location.pathname === appPage.url ? 'selected' : ''} routerLink={appPage.url} routerDirection="none" lines="none" detail={false}>
                            <IonIcon slot="start" ios={appPage.iosIcon} md={appPage.mdIcon} />
                            <p>{appPage.title}</p>
                        </IonItem>
                    </IonMenuToggle>
                );
            })
            }
        </>
    );
}

export default MenuType;